import { View, Text } from 'react-native'
import React from 'react'

const Settings = () => {
  return (
    <View>
      <Text>Settings</Text>
    </View>
  )
}

export default Settings